/* tsg.js — The Spa Guys interactive JS */
(function () {
  'use strict';

  /* ---- FIX MY SPA ---- */
  function initFixMySpa() {
    var probBtns = document.querySelectorAll('.tsg-prob');
    var result   = document.getElementById('tsg-fms-result');
    var rTitle   = document.getElementById('tsg-fms-result-title');
    var rBody    = document.getElementById('tsg-fms-result-body');
    var rLink    = document.getElementById('tsg-fms-result-link');

    if (!probBtns.length || !result) return;

    probBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        probBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        rTitle.textContent = btn.dataset.title   || '';
        rBody.textContent  = btn.dataset.body    || '';
        if (rLink && btn.dataset.url) {
          rLink.href = btn.dataset.url;
          rLink.style.display = 'inline-flex';
        }
        result.classList.add('is-visible');
      });
    });
  }

  /* ---- FAQ ACCORDION ---- */
  function initFaq() {
    var items = document.querySelectorAll('.tsg-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.tsg-faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
    if (items.length) items[0].classList.add('is-open');
  }

  /* ---- MOBILE NAV ---- */
  function initMobileNav() {
    var toggle = document.getElementById('tsg-hamburger');
    var drawer = document.getElementById('tsg-mobile-nav');
    var close  = document.getElementById('tsg-nav-close');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      drawer.classList.toggle('is-open');
      document.body.classList.toggle('tsg-nav-open');
    });
    if (close) close.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      document.body.classList.remove('tsg-nav-open');
    });
  }

  /* ---- STICKY HEADER SHADOW ---- */
  function initStickyHeader() {
    var header = document.querySelector('.tsg-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(0,0,0,0.35)'
        : 'none';
    }, { passive: true });
  }

  /* ---- CART COUNT ---- */
  function updateCartCount() {
    var counters = document.querySelectorAll('.tsg-cart-count');
    if (!counters.length) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ---- LIVE SEARCH ---- */
  function initSearch() {
    var input  = document.querySelector('.tsg-search-box input');
    var mobile = document.querySelector('.tsg-mobile-search');
    [input, mobile].filter(Boolean).forEach(function (el) {
      var timer;
      el.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (el.value.length < 2) return;
          window.location.href = '/search?type=product,article&q=' + encodeURIComponent(el.value);
        }, 600);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          window.location.href = '/search?type=product,article&q=' + encodeURIComponent(el.value);
        }
      });
    });
  }

  /* ---- ANNOUNCEMENT TICKER — pause on hover ---- */
  function initTicker() {
    var track = document.querySelector('.tsg-ticker-track');
    if (!track) return;
    track.addEventListener('mouseenter', function () {
      track.style.animationPlayState = 'paused';
    });
    track.addEventListener('mouseleave', function () {
      track.style.animationPlayState = 'running';
    });
  }

  /* ---- BOOT ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initFixMySpa();
    initFaq();
    initMobileNav();
    initStickyHeader();
    initSearch();
    initTicker();
    updateCartCount();
  });

})();
